import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'
import { DialogContent, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'

import ContainedButton from 'shared/components/Buttons/ContainedButton'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'
import { useNotificationContext } from 'shared/context/Notifications'
import isAxiosError from 'shared/utils/helpers/isAxiosError'
import CustomDialog from 'shared/components/CustomDialog'

import { removeProductService } from '../../services/removeProductService'
import { ReflinkDataType } from '../../types'

interface Props {
   productUuid: string
   wholesaleUuid: string
   open: boolean
   handleClose: () => void
   updateData: (data: ReflinkDataType) => void
}

export default function DeleteModal({ productUuid, wholesaleUuid, open, handleClose, updateData }: Props) {
   const [isLoading, setIsLoading] = useState(false)
   const { t } = useTranslation(['TRANSLATION', 'CLIENT_CART'])
   const theme = useTheme()
   const isMobile = useMediaQuery(theme.breakpoints.down('md'))
   const { addNotification } = useNotificationContext()

   function handleRemoveProduct() {
      const uuid = window.localStorage.getItem('uuid')
      const token = window.localStorage.getItem('reflink-verify-token')
      if (uuid && token) {
         setIsLoading(true)
         removeProductService(uuid, token, productUuid, wholesaleUuid)
            .then((res) => {
               addNotification(t('CLIENT_CART:deleteModal.productDeleted'), 'success')
               if (res.data) {
                  updateData(res.data)
               }
               handleClose()
            })
            .catch((error) => {
               if (isAxiosError<ErrorType>(error)) {
                  if (error.response?.data.errors[0].code === 'errors.authentication.reflink-code-expired') {
                     addNotification(t('CLIENT_CART:expired'), 'error')
                     window.localStorage.removeItem('reflink-verify-token')
                  } else {
                     addNotification(error.response?.data?.errors[0].code || 'failedSave', 'error')
                  }
               } else {
                  addNotification('failedSave', 'error')
               }
            })
            .finally(() => setIsLoading(false))
      }
   }

   return (
      <CustomDialog
         isLoading={!open}
         open={open}
         deleteVariant
         onClose={handleClose}
         content={
            <>
               <DialogTitle>{t('CLIENT_CART:deleteModal.confirmation')}</DialogTitle>
               {isMobile && <DialogContent />}
               <DialogActions>
                  <OutlinedButton isDelete variant="outlined" onClick={handleClose}>
                     {t('TRANSLATION:cancel')}
                  </OutlinedButton>
                  <ContainedButton isDelete disabled={isLoading} variant="contained" onClick={handleRemoveProduct}>
                     {t('TRANSLATION:delete')}
                  </ContainedButton>
               </DialogActions>
            </>
         }
      />
   )
}
